<template>
    <tr class=" border-t border-indigo-300">
        <td class="px-2 py-4 text-sm font-medium whitespace-nowrap text-gray-700 dark:text-gray-300">
            <span v-if="edit">
                <AppInput 
                    v-model='form.libelle' 
                    id='libelle'
                    :validations="['required']"
                    @hasError="handleFormError"
                    :check-on-unfocus="true"
                />
            </span>
            <span v-else>
                {{ expense.libelle }}
            </span>
        </td>
        <td class="px-2 py-4 text-sm font-medium whitespace-nowrap text-gray-700 dark:text-gray-300">
            <span v-if="edit">
                <AppInput 
                    v-model='form.amount'
                    id='amount'
                    :validations="['number', 'required']"
                    @hasError="handleFormError"
                    :check-on-create="false"
                    :check-on-unfocus="true"
                    icon="euro-sign"
                />
            </span>
            <span v-else>
                {{ expense.amount }} €
            </span>
        </td>
        <td class="px-2 py-4 text-sm font-medium text-gray-700 dark:text-gray-300">
            <div v-if="edit">
                <DatePicker 
                    v-model='form.paiementDate' 
                    class="mt-3 mr-2"
                    id='paiementDate' 
                />
            </div>
            <span v-else>
                {{ formatDate(form.paiementDate) }}
            </span>
        </td>
        <td class="px-2 py-4 text-sm whitespace-nowrap">
            <span 
                v-if="!edit"
                class="flex items-center justify-end"
            >
                <button class="btn-secondary mr-1 px-3" @click="edit = true">
                    <font-awesome-icon class="text-sm" :icon="['fa', 'edit']" />
                </button>
                <button class="btn-danger" @click.prevent="confirmRemoveExpense(expense.uuid);">
                    <font-awesome-icon class="text-sm text-white" :icon="['fa', 'times']" />
                </button>
            </span>
            <span 
                v-else
                class="flex items-center justify-end"
            >
                <button class="btn-secondary mr-1" @click="edit = false">
                    <font-awesome-icon class="text-md" :icon="['fa', 'undo']" />
                </button>
                <button class="btn-success" :class="checkFieldValid ? '' : 'cursor-not-allowed bg-emerald-300 border-emerald-300 hover:bg-emerald-300 hover:border-emerald-300'" @click="editExpense()">
                    <font-awesome-icon v-if="editLoader" class="text-sm animate-spin" :icon="['fas', 'spinner']"  />
                    <font-awesome-icon v-else class="text-sm" :icon="['fa', 'check']" />
                </button>
            </span>
        </td>
    </tr>
</template>

<script>

import AppInput from './../../../form/AppInput';
import DatePicker from './../../../form/DatePicker';
export default {
    components: {
        AppInput,
        DatePicker
    },

    emits: ['refresh'],

    data() {
        return {
            edit: false,
            openExpense: false,
            form: {},
            formInvalid: [],
            editLoader: false
        }
    },

    props: {
        expense: {
            type: Object,
            default() {
                return {}
            }
        },
    },

    created() {
        this.form = this.expense
        this.form.paiementDate = this.expense.paiement_date
    },

    computed: {
        checkFieldValid() {
            return this.formInvalid.length === 0 && this.form.libelle.length !== 0 && this.form.amount;
        }
    },

    methods: {
        handleFormError(event) {
            if (event.value && !this.formInvalid.includes(event.name)) {
                this.formInvalid.push(event.name);
            }

            if (!event.value && this.formInvalid.includes(event.name)) {
                this.formInvalid = this.formInvalid.filter(f => f !== event.name)
            }
        },

        confirmRemoveExpense(expenseUuid) {
            this.$confirm({
                variant: 'danger',
                title: 'Supprimer la dépense',
                message: "Vous êtes sur le point de supprimer cette dépense. Cette action est irréversible, en êtes-vous sûr ?",
                confirmText: 'Supprimer',
                action: () => this.removeExpense(expenseUuid),
            });
        },

        async removeExpense(expenseUuid) {
            if (!this.$route.params.bienUuid || !expenseUuid) {
                return;
            }

            await this.$api.bien.removeExpense(this.$route.params.bienUuid, expenseUuid)
            .then(async () => {
                this.$toast({title: 'Succès', description: "La dépense à bien été supprimé."}, this.$toastSuccess);
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.$emit('refresh')
        },

        async editExpense() {
            if (!this.$route.params.bienUuid || !this.form.uuid || !this.checkFieldValid) {
                return;
            }

            this.editLoader = true

            await this.$api.bien.updateExpense(this.$route.params.bienUuid, this.form.uuid, {
                libelle: this.form.libelle,
                amount: this.form.amount,
                paiement_date: this.form.paiementDate,
            })
            .then(async () => {
                this.$toast({title: 'Succès', description: "La dépense à bien été enregistré."}, this.$toastSuccess);
                this.$emit('refresh')
            })
            .catch((err) => {
                console.log(err);
                this.$toast({title: 'Erreur', description: "Une erreur est survenue, veuillez réessayer plus tard."}, this.$toastError);
            })

            this.editLoader = false
            this.edit = false
        }
    }
};
</script>
